<template>
  <div>
    <span
      @click="showGames = !showGames"
      ref="gamesButton"
      class="user-item-bottom"
      >{{ $t("myFriends.inviteGame") }}</span
    >
    <InviteToGame
      v-if="showGames"
      v-click-outside="{
        exclude: ['gamesButton'],
        handler: 'clickOutsideGames',
      }"
      :id="id"
      class="friends-games invite"
    ></InviteToGame>
  </div>
</template>

<script>
import InviteToGame from "@/components/Blocks/InviteToGame";

export default {
  name: "InviteOpener",
  props: {
    i18n: Object,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    InviteToGame,
  },
  data() {
    return {
      showGames: false,
    };
  },
  methods: {
    clickOutsideGames() {
      this.showGames = false;
    },
  },
};
</script>
